import React, { useState, useEffect, useRef } from "react";
import NervousLogo from './../../../../images/nervouslogo.png'
import NervousPlusLogo from './../../../../images/nervouspluslogo.png'
import NerveProLogo from './../../../../images/nerveprologo.png'
import InviteOnlyLogo from './../../../../images/inviteonlylogo.png'
import ArtistImage from './../../../../images/artistprofilepic.png'
import CustomDropdownDown from './../../../../images/customdropdowndown.png'
import CustomDropdownUp from './../../../../images/customdropdownup.png'
import CrossIcon from './../../../../images/crossicon.png'
import profilepicempty from './../../../../images/profileavatarempty.png'
import MobilePopup from './../../../../images/mobilepopup.png'
import ReactModal from 'react-modal';
import './Home.css'
import { Trans, useTranslation } from 'react-i18next'
import i18next from "i18next"
import Cookies from 'universal-cookie';
import AvatarEditor from 'react-avatar-editor'
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import minusicon from './../../../../images/minusicon.png'
import plusicon from './../../../../images/plusicon.png'
import Select from 'react-select'
import { useNavigate } from "react-router-dom";
import { useJwt, decodeToken } from "react-jwt";
import { logtoWix } from "../../../Helpers/LogToWix";


function Home({ func, nav, hidedashboard }) {
    const [height, setHeight] = useState()
    const inputRef = useRef(null)
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const editor = useRef(null);
    const [profileImage, setProfileImage] = useState("")
    const [resizedprofileImg, setResizedProfileImg] = useState("")
    const [albumImageError, setAlbumImageError] = useState(false)
    const [ImageDragActive, setImageDragActive] = useState(false)
    const [ResizeImgPopup, setResizeImgPopup] = useState(false)
    const [statsoption, setStatsOption] = useState(1)
    const { t, i18n } = useTranslation();
    const [imgsize, setImgSize] = useState(0);
    const [scale, setScale] = useState(1);
    const [hoverprofile, setHoverProfile] = useState(false)
    const cookies = new Cookies(null, { path: '/' });
    const [featuredArtist2, setFeaturedArtist2] = useState("")
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    })
    const navigate = useNavigate();
    const hasLogged = useRef(false);

    const handleResize = () => {
        console.log(window.innerWidth)
        setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    }

    const handleImgResize = (event, newValue) => {
        setImgSize(newValue);
    };

    useEffect(() => {
        var newScale = 1 + imgsize / 100
        setScale(newScale)
    }, [imgsize])

    const increaseImgScale = () => {
        if (imgsize < 100) {
            console.log(imgsize)
            console.log((imgsize - imgsize % 10) + 10)
            setImgSize((imgsize - imgsize % 10) + 10)
        }
    }

    const decreaseImgScale = () => {
        console.log(imgsize)
        if (imgsize - 10 >= 0) {
            setImgSize((imgsize - imgsize % 10) - 10)
        }
    }

    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    useEffect(() => {
        topFunction()
        nav("Home")
        hidedashboard(true)
        window.addEventListener("resize", handleResize, false);

        if (!hasLogged.current) {
            if (cookies.get('token') !== undefined) {
                if (decodeToken(cookies.get('token')) !== null) {
                    logtoWix(decodeToken(cookies.get('token')).email, "pageview", "Artist Dashboard Home Page", { "desc": "User opened the artist dashboard home page" })
                    hasLogged.current = true;
                } else {
                    logtoWix("anonymous user", "pageview", "Artist Dashboard Home Page", { "desc": "User opened the artist dashboard home page" })
                    hasLogged.current = true;
                }
            } else {
                logtoWix("anonymous user", "pageview", "Artist Dashboard Home Page", { "desc": "User opened the artist dashboard home page" })
                hasLogged.current = true;
            }
        }

    }, [])

    // const ref = useRef(null)
    // func(height)

    // useEffect(() => {
    //     setHeight(ref.current.clientHeight)
    //   },[])

    const onButtonClick = () => {
        inputRef.current.click();
    }


    const handleImageDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.type === "dragenter" || e.type === "dragover") {
            setImageDragActive(true);
        } else if (e.type === "dragleave") {
            setImageDragActive(false);
        }
    }
    const changeFeaturedArtist2Handler = value => {
        setFeaturedArtist2(value)
    }

    const TrackDetailsColourStyles = {
        control: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: '#232B33',
                width: '26.5em',
                height: '3em',
                position: 'relative',
                borderTopLeftRadius: '4px',
                borderTopRightRadius: '4px',
                borderBottomRightRadius: isFocused ? '0px' : '4px',
                borderBottomLeftRadius: isFocused ? '0px' : '4px',
                color: 'rgba(255, 255, 255, 1)',
                borderTop: isFocused ? 'rgba(255,255,255,80%) 1px solid' : 'rgba(255,255,255,80%) 1px solid',
                borderBottom: isFocused ? 'none' : 'rgba(255,255,255,80%) 1px solid',
                boxShadow: isFocused ? '0 0 0 1px rgba(255,255,255,80%)' : 'none',
                marginTop: '1.2em',
                "&:hover": {
                    backgroundColor: "rgba(254,254,254,20%)",
                    borderColor: 'rgba(255,255,255,80%)'
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    left: '50%',
                    bottom: 0,
                    width: menuIsOpen ? '80%' : '0%', // Width of the border
                    height: '2px',
                    backgroundColor: 'black', // Color of the border
                    transform: 'translateX(-50%)', // Center the border
                    transition: 'width 0.3s', // Smooth transition for width change
                }
            };
        },
        menu: styles => ({
            ...styles,
            color: 'rgba(255, 255, 255, 1)',
            borderColor: '#636468',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
            borderBottom: 'rgba(255,255,255,80%) 1px solid',
            borderLeft: 'rgba(255,255,255,80%) 1px solid',
            borderRight: 'rgba(255,255,255,80%) 1px solid',
            marginTop: '-0em',
            width: '26.5em',
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                backgroundColor: '#18191F',
                color: 'rgba(255, 255, 255, 1)',
                cursor: isDisabled ? 'not-allowed' : 'default',
                marginTop: '-0.3em',

                marginBottom: '-0.3em',
                "&:hover": {
                    backgroundColor: 'rgba(0,0,0,100%)'
                }
            };
        },
        valueContainer: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return {
                ...styles,
                alignSelf: 'center',
                width: '70%', // Make the value container 80% width
                borderBottom: menuIsOpen ? '1px solid rgba(255,255,255,80%)' : 'none', // Add the bottom border
                marginLeft: '0em', // Align it to the right
            };
        },
        input: (styles) => ({
            ...styles,
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%',
            color: 'rgba(255, 255, 255, 1)'
        }),
        singleValue: (styles) => ({
            ...styles,
            color: 'rgba(255, 255, 255, 1)',
            FontFamily: 'ClashGrotesk-Variable,sans-serif',
            FontSize: '1rem',
            FontWeight: 'medium',
            LineHeight: '150%',
            LetterSpacing: '0%'
        }),
        hover: styles => ({
            backgroundColor: 'rgba(255,255,255,16%)',
        }),
        noOptionsMessage: (styles) => ({
            ...styles,
            width: '27.5em',
            backgroundColor: '#232B33',
            color: 'rgba(255, 255, 255, 0.6)',
            marginTop: '-0.3em',
            marginBottom: '-0.3em',
            paddingBottom: '2em',
            borderBottomLeftRadius: '4px',
            borderBottomRightRadius: '4px',
            borderLeft: 'rgba(255,255,255,80%) 1px solid',
            borderRight: 'rgba(255,255,255,80%) 1px solid',
            borderBottom: 'rgba(255,255,255,80%) 1px solid',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: '2em'
        }),
        menuList: (base) => ({
            ...base,

            "::-webkit-scrollbar": {
                width: "0px",
                height: "0px",
            },
            "::-webkit-scrollbar-track": {
                background: "#f1f1f1"
            },
            "::-webkit-scrollbar-thumb": {
                background: "#888"
            },
            "::-webkit-scrollbar-thumb:hover": {
                background: "#555"
            }
        })
    };

    const handleImageDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setImageDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            var filelist = []

            const img = new Image();
            img.src = URL.createObjectURL(e.dataTransfer.files[0])

            img.onload = () => {
                console.log(img.height);
                console.log(img.width);
                if (img.height !== img.width) {
                    setAlbumImageError(true)
                } else if (img.height < 3000 || img.height > 6000 || img.width < 3000 || img.width > 6000) {
                    setAlbumImageError(true)
                } else {
                    setAlbumImageError(false)
                    // filelist.push(e.dataTransfer.files[0])
                    setProfileImage([e.dataTransfer.files[0]])
                    setResizeImgPopup(true)
                }
            }
        }

    };

    const handleImageChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            const filelist = []
            const img = new Image();
            img.src = URL.createObjectURL(e.target.files[0])
            img.onload = () => {
                console.log(img.height);
                console.log(img.width);
                if (img.height !== img.width) {
                    setAlbumImageError(true)
                } else if (img.height < 3000 || img.height > 6000 || img.width < 3000 || img.width > 6000) {
                    setAlbumImageError(true)
                } else {
                    setAlbumImageError(false)
                    // filelist.push(e.target.files[0])
                    setProfileImage([e.target.files[0]])
                    setResizeImgPopup(true)
                }
            }

        }
    };

    const getImageUrl = async () => {
        const dataUrl = editor.current.getImage().toDataURL()
        const res = await fetch(dataUrl)
        console.log(res)
        const blob = await res.blob()
        console.log(blob)
        console.log(URL.createObjectURL(blob))
        // setProfileUrl([URL.createObjectURL(blob)])
        setResizedProfileImg(window.URL.createObjectURL(blob))
    }

    const CustomSliderStyles = {
        color: "#dfdfdf",
        '& .MuiSlider-thumb': {
            color: "linear-gradient(97deg, rgba(156,79,255,1) 0%, rgba(130,119,255,1) 100%)",
            height: 16,
            width: 16,
            backgroundImage: "linear-gradient(97deg, rgba(156,79,255,1) 0%, rgba(130,119,255,1) 100%)"
        },
        '& .MuiSlider-track': {
            color: "transparent",
            height: 2
        },
        '& .MuiSlider-rail': {
            color: "#dfdfdf",
            backgroundColor: "#dfdfdf",
            height: 2
        },
        '& .MuiSlider-active': {
            color: "none"
        }
    };

    const artistOptions = [{ value: 'BoySam', label: 'BoySam' },
    { value: 'Jae Ro', label: 'Jae Ro' },
    { value: 'Joey Newman', label: 'Joey Newman' },
    { value: 'Mimi Page', label: 'Mimi Page' },
    { value: 'NCSOUND', label: 'NCSOUND' }]


    function closeResizeImgPopup() {
        setResizeImgPopup(false)
    }

    return (
        <div>
            {/* ******************************************** */}


            {/* DESKTOP VIEW */}

            {
                dimensions.width >= 1024 &&
                <div className="HomeContainer" style={{ minHeight: '100vh', height: 'auto', paddingBottom: '10em' }}>
                    <ReactModal
                        isOpen={ResizeImgPopup}
                        overlayClassName="Overlay"
                        contentLabel="Example Modal"
                        onRequestClose={closeResizeImgPopup} // closes the modal when the user presses the escape key
                        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                        style={{
                            content: {
                                width: '30em',
                                height: '26em',
                                margin: 'auto',
                                backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderRadius: '8px',
                                border: '0.5px solid rgba(255,255,255,25%)'
                            }
                        }}
                    >
                        <img src={CrossIcon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => { setResizeImgPopup(false); setProfileImage("") }} />


                        {
                            profileImage.length !== 0 &&
                            <AvatarEditor
                                ref={editor}
                                image={URL.createObjectURL(profileImage[0])}
                                width={250}
                                height={250}
                                border={0}
                                // color={[255, 255, 255, 0.6]} // RGBA
                                scale={scale}
                                rotate={0}
                                borderRadius={8}
                            />
                        }

                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '2em', marginBottom: '2em', alignItems: 'center' }}>
                            <img src={minusicon} className="ImageResizeIcon" style={{ width: '1em', height: '1em', padding: '0.5em', marginTop: '-0.2em', cursor: 'pointer' }} onClick={() => decreaseImgScale()} />
                            <Box sx={{ width: 250, marginRight: 2, marginLeft: 2 }}>
                                <Slider value={imgsize} onChange={handleImgResize} sx={CustomSliderStyles} />
                            </Box>
                            <img src={plusicon} className="ImageResizeIcon" style={{ width: '1em', height: '1em', padding: '0.5em', marginTop: '-0.2em', cursor: 'pointer' }} onClick={() => increaseImgScale()} />
                        </div>





                        <div className="IUnderstandBtn" style={{ cursor: 'pointer', maxWidth: '15em' }} onClick={() => { getImageUrl(); setResizeImgPopup(false); }}>Save image</div>
                    </ReactModal>

                    <div className="HomeHeader">HOME</div>


                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {
                            cookies.get("artistname").length !== 0 &&
                            <div className="ArtistWidget">
                                <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%' }}>



                                    {
                                        profileImage.length === 0 &&
                                        <form id="profilepiccontainer" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', width: '10.875em', height: '10.875em', borderRadius: '8px', marginTop: '1.5em', marginLeft: '0.5em', alignSelf: 'center' }} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                            <input ref={inputRef} type="file" id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                            <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : ""}>
                                                <div className="CoverPicUpload2" style={{ backgroundImage: `url(${profilepicempty})`, backgroundSize: 'cover' }} onMouseOver={() => setHoverProfile(true)} onMouseLeave={() => setHoverProfile(false)}>
                                                    {/* <span className="CoverartText"> 
                                           
                                                <button className="upload-button" onClick={onButtonClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                                                {t('Browseyourfiles')} 
                                                        </button> 
                                            </span> */}
                                                    {
                                                        hoverprofile &&
                                                        <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                            <div style={{ width: '98%', height: '98%', backgroundColor: 'rgba(0,0,0,50%)', borderRadius: '8px' }} />
                                                            <div className="UploadImageBtn" onClick={() => inputRef.current.click()}>
                                                                Upload <br /> image
                                                            </div>
                                                            {/* <button className="upload-button" onClick={onButtonClick} style={{color:'#FFFFFF',textDecoration:'underline',position:'absolute'}}>
                                                    Upload <br/> image
                                                    </button>  */}
                                                        </div>
                                                    }
                                                </div>
                                            </label>
                                            {ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div>}
                                        </form>
                                    }


                                    {
                                        profileImage.length !== 0 && resizedprofileImg.length === 0 &&
                                        <form id="profilepiccontainer" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', width: '10.875em', height: '10.875em', borderRadius: '8px', marginTop: '1.5em', marginLeft: '0.5em', alignSelf: 'center' }} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                            <input ref={inputRef} type="file" style={{ backgroundColor: 'pink' }} id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                            <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : ""}>
                                                <div style={{ position: 'relative' }}>
                                                    <img src={URL.createObjectURL(profileImage[0])} className="CoverPicUpload2" />

                                                </div>
                                            </label>

                                            {ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div>}
                                        </form>

                                    }

                                    {
                                        resizedprofileImg.length !== 0 &&

                                        <img src={resizedprofileImg} className="CoverPicUpload2" style={{ cursor: 'auto', borderRadius: '8px', marginTop: '1.5em', marginLeft: '0.5em', alignSelf: 'center' }} />



                                    }

                                    <div style={{ maxWidth: '15.43em', alignSelf: 'center', width: '80%' }}>
                                        <div className="ProfileName">
                                            {cookies.get("artistname")}
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginTop: '0.5em', width: '89.42%', alignItems: 'center' }}>
                                            <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{ width: '1em', height: '1em', marginTop: '-0.2em', marginRight: '0.28em' }} />
                                            <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                                        </div>
                                        <div className="ProfileType">
                                            {t('Artist')}
                                        </div>
                                    </div>
                                    <div className="ReleaseMusicBtn" onClick={() => navigate("/Dashboard/releasemusic")} style={{ cursor: 'pointer' }}>{t('ReleaseMusic')}</div>
                                    <div className="StatDisclaimer">{t('Afterreleaseittakes')}</div>

                                </div>
                            </div>
                        }

                        {
                            cookies.get("artistname").length === 0 &&
                            <div style={{
                                backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ffs040ctlguylhq0jz2d")`,
                                height: '40.375em',
                                width: '19.43em',
                                backgroundSize: 'cover',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: '#18222B',
                                marginBottom: '4em',
                                marginLeft: '2.5em',
                                marginRight: '1em'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginTop: '19.5em', width: '79.42%' }}>
                                    <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{ width: '1em', height: '1em', marginRight: '0.28em' }} />
                                    <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                                </div>
                                <span className="WelcomeToNerveH1"><span style={{ fontWeight: '500' }}>Welcome to</span>
                                    <span style={{ fontWeight: '400' }}>&nbsp;N3RVE</span>
                                    <span style={{ fontWeight: '600' }}>&nbsp;.</span>
                                </span>
                                <div className="WelcomeToNerveH2">First, let’s pick your artist name so that the world knows who you are.</div>
                                <div className="Setupartistnamebtn" style={{ cursor: 'pointer' }} onClick={() => navigate("/Dashboard/settings")}>Set up Artist Name</div>
                            </div>
                        }


                        <div className="Promotions">
                            {/* <div className="Promotion1">
                                    <div className="PromotionDate">SEP 23, 2023</div>
                                    <div className="PromotionHeading">Welcome to the New Wave of Independence</div>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rgvizsuqugtlujtnee29"} alt="Sign to yourself" className="PromotionImage"/>
                                    <div className="PromotionDesc">As a new industry alternative for independent artists, UnitedMasters provides premium music distribution services and facilitates unique partnerships between artists and the world's biggest brands.</div>
                                    <div className="PromotionBtn" onClick={()=>navigate("/Dashboard/releasemusic")} style={{cursor:'pointer'}}>Upload a Track to Get Started</div>
                            </div> */}

                            <div className="Promotion1">
                                <div className="PromotionDate">SEP 05, 2023</div>
                                <div className="PromotionHeading">GET YOUR MUSIC HEARD</div>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/lupwwwagaqahjlj5wnp8"} alt="Sign to yourself" className="PromotionImage" />
                                <div className="PromotionDesc">Make the most of your music. With N3RVE, you can distribute your music to major streaming platforms without giving up ownership of your masters.<br />
                                    Here's how to get started:<br />
                                    • Step 1: Upload Your Music<br />
                                    Drag & Drop your tracks or select them from a folder. If you're using the website, you can also upload
                                    them trem a brobbox account<br />
                                    • Step 2: Add The Extras<br />
                                    Add album artwork, featured artist details, and select your release date. We'll add the rest for you Once everything looks good, hit submit.<br />
                                    Once your release is approved, you can promote your musie even more through Masterlinks.
                                </div>
                                <div className="PromotionBtn" onClick={() => navigate("/Dashboard/releasemusic")} style={{ cursor: 'pointer' }}>Upload a Track</div>
                            </div>

                            <div className="Promotion1">
                                <div className="PromotionDate">AUG 12, 2023</div>
                                <div className="PromotionHeading">GET TO KNOW YOUR FANS: <br /> WHERE THEY ARE WHAT THEY LOVE ABOUT YOU, <br /> AND HOW TO BETTER CONNECT WITH THEM</div>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dvwroarubtmcajoytekm"} alt="Sign to yourself" className="PromotionImage" />
                                <div className="PromotionDesc">Connect your socials to learn who your fans are, what they like about you, and how to grow your audience - at every turn of your career. <br />
                                    Fueled by your data, we're here to give you the facts and turn your social numbers into real fans' love.
                                </div>
                                <div className="PromotionBtn">Connect My Account</div>
                            </div>
                        </div>
                    </div>
                </div>
            }



            {/* ******************************************** */}


            {/* TABLET VIEW */}

            {
                dimensions.width >= 768 && dimensions.width < 1024 &&
                <div className="HomeContainer" style={{ paddingBottom: '10em' }}>

                    <ReactModal
                        isOpen={false}
                        contentLabel="Example Modal"
                        className="TabletPopupContainer"
                        overlayClassName="Overlay"
                    >

                        <img src={MobilePopup} style={{ marginTop: '2em', width: '100%', marginBottom: '1em', height: '24.4em' }} />


                        <div className="MobilePopupHeader">
                            Experience Full Features on Desktop
                        </div>

                        <div className="MobilePopupInfo">
                            Looks like you're on mobile. For the full suite of features, please switch to desktop. Some functionalities might be limited here.
                        </div>

                    </ReactModal>

                    {/* <div className="HomeHeader" style={{marginTop:'1em'}}>HOME</div>
                <div style={{display:'flex',flexDirection:'row'}}>
                    {
                    cookies.get("artistname").length!==0 &&
                    <div className="ArtistWidget">
                            <div style={{display:'flex',flexDirection:'column',alignSelf:'center',width:'100%'}}>
                                {
                                    profileImage.length===0 &&
                                            <div className="ProfilePictureUpload" style={{cursor:'pointer'}}>
                                                Upload profile image
                                            </div>
                                }

                                {
                                    profileImage.length!==0 &&
                                        <img src={ArtistImage} className="ProfilePictureUpload" style={{border:'none'}}/>
                                }   
                                
                                <div className="ProfileName">
                                    {cookies.get("artistname")}
                                </div>
                                <div style={{display:'flex',flexDirection:'row',alignSelf:'center',marginTop:'0.5em',width:'79.42%'}}>
                                    <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{width:'1em',height:'1em',marginRight:'0.28em'}}/>
                                    <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                                </div>
                                <div className="ProfileType">
                                {t('Artist')}
                                </div>
                                <div className="ReleaseMusicBtn" onClick={()=>nav("ReleaseMusic")} style={{cursor:'pointer'}}>{t('ReleaseMusic')}</div>
                                <div className="StatDisclaimer">{t('Afterreleaseittakes')}</div>

                                <div style={{display:'flex',flexDirection:'column'}}>
                                    <div style={{display:'flex',flexDirection:'row',marginTop: '1.714em',width:'79.42%',alignSelf:'center'}}>
                                        {
                                            statsoption===1 && 
                                            <div onClick={()=> setStatsOption(1)} className="StatSliderHeaderSel">{t('1wk')}</div>
                                        }
                                        {
                                            statsoption!==1 && 
                                            <div onClick={()=> setStatsOption(1)} className="StatSliderHeader">{t('1wk')}</div>
                                        }
                                        {
                                            statsoption===2 && 
                                            <div onClick={()=> setStatsOption(2)} className="StatSliderHeaderSel">{t('1mo')}</div>
                                        }
                                        {
                                            statsoption!==2 && 
                                            <div onClick={()=> setStatsOption(2)} className="StatSliderHeader">{t('1mo')}</div>
                                        }
                                        {
                                            statsoption===3 && 
                                            <div onClick={()=> setStatsOption(3)} className="StatSliderHeaderSel">{t('All')}</div>
                                        }
                                        {
                                            statsoption!==3 && 
                                            <div onClick={()=> setStatsOption(3)} className="StatSliderHeader">{t('All')}</div>
                                        }
                                    </div>
                                    {
                                        statsoption===1 && 
                                        <div style={{display:'flex',flexDirection:'row',alignSelf:'center',width:'79.42%',justifyContent:'space-between',marginTop:'3.5em'}}>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <div className="StatHeader">{t('Streams')}</div>
                                                <div className="StatInfo">85.5k</div>
                                            </div>

                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <div className="StatHeader">{t('Followers')}</div>
                                                <div className="StatInfo">+3.8k</div>
                                            </div>
                                        </div>
                                    }


                                    {
                                        statsoption===2 && 
                                        <div style={{display:'flex',flexDirection:'row',alignSelf:'center',width:'79.42%',justifyContent:'space-between',marginTop:'3.5em'}}>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <div className="StatHeader">{t('Streams')}</div>
                                                <div className="StatInfo">402k</div>
                                            </div>

                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <div className="StatHeader">{t('Followers')}</div>
                                                <div className="StatInfo">+23.9k</div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        statsoption===3 && 
                                        <div style={{display:'flex',flexDirection:'row',alignSelf:'center',width:'79.42%',justifyContent:'space-between',marginTop:'3.5em'}}>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <div className="StatHeader">{t('Streams')}</div>
                                                <div className="StatInfo">1.93M</div>
                                            </div>

                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <div className="StatHeader">{t('Followers')}</div>
                                                <div className="StatInfo">302.9k</div>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className="SocialFollowersHeader">{t('Socialfollowers')}</div>
                                <div style={{display:'flex',flexDirection:'row',width:'79.42%',alignSelf:'center',justifyContent:'space-between',marginBottom:'1.5em'}}>
                                    <div className="SocialMedia">{t('Facebook')}</div>
                                    <div className="SocialStat">10.8k</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',width:'79.42%',alignSelf:'center',justifyContent:'space-between',marginBottom:'1.5em'}}>
                                    <div className="SocialMedia">{t('Instagram')}</div>
                                    <div className="SocialStat">41.5k</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',width:'79.42%',alignSelf:'center',justifyContent:'space-between',marginBottom:'1.5em'}}>
                                    <div className="SocialMedia">{t('Soundcloud')}</div>
                                    <div className="SocialStat">21k</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',width:'79.42%',alignSelf:'center',justifyContent:'space-between',marginBottom:'1.5em'}}>
                                    <div className="SocialMedia">{t('Youtube')}</div>
                                    <div className="SocialStat">12.9k</div>
                                </div>

                                <div style={{display:'flex',flexDirection:'row',width:'79.42%',alignSelf:'center',justifyContent:'space-between',marginBottom:'1em'}}>
                                    <div className="SocialMedia">{t('Twitter')}</div>
                                    <div className="SocialStat">23k</div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        cookies.get("artistname").length===0 &&
                        <div  style={{ 
                            backgroundImage:`url(${ArtistNameNotFound})`, 
                            height:'40.375em',
                            width:'37.09%',
                            backgroundSize:'cover',
                            display:'flex',
                            flexDirection:'column',
                            alignItems:'center',
                            backgroundColor:'#18222B',
                            marginBottom:'4em',
                            marginLeft:'2.5em',
                            marginRight:'1em'
                        }}>
                            <div style={{display:'flex',flexDirection:'row',alignSelf:'center',marginTop:'19.5em',width:'79.42%'}}>
                                    <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{width:'1em',height:'1em',marginRight:'0.28em'}}/>
                                    <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                            </div>
                            <span className="WelcomeToNerveH1"><span style={{fontWeight:'500'}}>Welcome to</span> 
                                                                <span style={{fontWeight:'400'}}>&nbsp;N3RVE</span> 
                                                                <span style={{fontWeight:'600'}}>&nbsp;.</span>
                            </span>
                            <div className="WelcomeToNerveH2">First, let’s pick your artist name so that the world knows who you are.</div>
                            <div className="Setupartistnamebtn" style={{cursor:'pointer'}} onClick={()=>nav("Settings")}>Set up Artist Name</div>
                        </div>
                    }
                        

                        <div className="Promotions" style={{width:'55%'}}>
                            <div className="Promotion1">
                                    <div className="PromotionDate">SEP 23, 2023</div>
                                    <div className="PromotionHeading">Welcome to the New Wave of Independence</div>
                                    <img src={HomePromotion1} alt="Sign to yourself" className="PromotionImage"/>
                                    <div className="PromotionDesc">As a new industry alternative for independent artists, UnitedMasters provides premium music distribution services and facilitates unique partnerships between artists and the world's biggest brands.</div>
                                    <div className="PromotionBtn" onClick={()=>nav("ReleaseMusic")} style={{cursor:'pointer'}}>Upload a Track to Get Started</div>
                            </div>
                            
                            <div className="Promotion1">
                                    <div className="PromotionDate">SEP 05, 2023</div>
                                    <div className="PromotionHeading">GET YOUR MUSIC HEARD</div>
                                    <img src={HomePromotion2} alt="Sign to yourself" className="PromotionImage"/>
                                    <div className="PromotionDesc">Make the most of your music. With N3RVE, you can distribute your music to major streaming platforms without giving up ownership of your masters.<br/>
                                    Here's how to get started:<br/>
                                    • Step 1: Upload Your Music<br/>
                                    Drag & Drop your tracks or select them from a folder. If you're using the website, you can also upload
                                    them trem a brobbox account<br/>
                                    • Step 2: Add The Extras<br/>
                                    Add album artwork, featured artist details, and select your release date. We'll add the rest for you Once everything looks good, hit submit.<br/>
                                    Once your release is approved, you can promote your musie even more through Masterlinks.
                                    </div>
                                    <div className="PromotionBtn" onClick={()=>nav("ReleaseMusic")} style={{cursor:'pointer'}}>Upload a Track</div>
                            </div>

                            <div className="Promotion1">
                                    <div className="PromotionDate">AUG 12, 2023</div>
                                    <div className="PromotionHeading">GET TO KNOW YOUR FANS: <br/> WHERE THEY ARE WHAT THEY LOVE ABOUT YOU, <br/> AND HOW TO BETTER CONNECT WITH THEM</div>
                                    <img src={HomePromotion3} alt="Sign to yourself" className="PromotionImage"/>
                                    <div className="PromotionDesc">Connect your socials to learn who your fans are, what they like about you, and how to grow your audience - at every turn of your career. <br/>
                                    Fueled by your data, we're here to give you the facts and turn your social numbers into real fans' love.
                                    </div>
                                    <div className="PromotionBtn">Connect My Account</div>
                            </div>
                        </div>
                </div> */}
                    <ReactModal
                        isOpen={ResizeImgPopup}
                        overlayClassName="Overlay"
                        contentLabel="Example Modal"
                        onRequestClose={closeResizeImgPopup} // closes the modal when the user presses the escape key
                        shouldCloseOnOverlayClick={true} // closes the modal when the user clicks outside of it
                        style={{
                            content: {
                                width: '30em',
                                height: '26em',
                                margin: 'auto',
                                backgroundImage: 'linear-gradient(7.87deg, #182028 50.13%, #273644 96.12%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                borderRadius: '8px',
                                border: '0.5px solid rgba(255,255,255,25%)'
                            }
                        }}
                    >
                        <img src={CrossIcon} style={{ height: '1.5em', width: '1.5em', position: 'absolute', right: '1.5em', top: '1.5em', cursor: 'pointer' }} onClick={() => { setResizeImgPopup(false); setProfileImage("") }} />


                        {
                            profileImage.length !== 0 &&
                            <AvatarEditor
                                ref={editor}
                                image={URL.createObjectURL(profileImage[0])}
                                width={250}
                                height={250}
                                border={0}
                                // color={[255, 255, 255, 0.6]} // RGBA
                                scale={scale}
                                rotate={0}
                                borderRadius={8}
                            />
                        }

                        <div style={{ display: 'flex', flexDirection: 'row', marginTop: '2em', marginBottom: '2em', alignItems: 'center' }}>
                            <img src={minusicon} className="ImageResizeIcon" style={{ width: '1em', height: '1em', padding: '0.5em', marginTop: '-0.2em', cursor: 'pointer' }} onClick={() => decreaseImgScale()} />
                            <Box sx={{ width: 250, marginRight: 2, marginLeft: 2 }}>
                                <Slider value={imgsize} onChange={handleImgResize} sx={CustomSliderStyles} />
                            </Box>
                            <img src={plusicon} className="ImageResizeIcon" style={{ width: '1em', height: '1em', padding: '0.5em', marginTop: '-0.2em', cursor: 'pointer' }} onClick={() => increaseImgScale()} />
                        </div>





                        <div className="IUnderstandBtn" style={{ cursor: 'pointer', maxWidth: '15em' }} onClick={() => { getImageUrl(); setResizeImgPopup(false); }}>Save image</div>
                    </ReactModal>

                    <div className="HomeHeader">HOME</div>


                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {
                            cookies.get("artistname").length !== 0 &&
                            <div className="ArtistWidget">
                                <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%' }}>



                                    {
                                        profileImage.length === 0 &&
                                        <form id="profilepiccontainer" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', width: '10.875em', height: '10.875em', borderRadius: '8px', marginTop: '1.5em', marginLeft: '0.5em', alignSelf: 'center' }} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                            <input ref={inputRef} type="file" id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                            <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : ""}>
                                                <div className="CoverPicUpload2" style={{ backgroundImage: `url(${profilepicempty})`, backgroundSize: 'cover' }} onMouseOver={() => setHoverProfile(true)} onMouseLeave={() => setHoverProfile(false)}>
                                                    {/* <span className="CoverartText"> 
                                           
                                                <button className="upload-button" onClick={onButtonClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                                                {t('Browseyourfiles')} 
                                                        </button> 
                                            </span> */}
                                                    {
                                                        hoverprofile &&
                                                        <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                                            <div style={{ width: '98%', height: '98%', backgroundColor: 'rgba(0,0,0,50%)', borderRadius: '8px' }} />
                                                            {/* <div className="UploadImageBtn" onClick={()=>inputRef.current.click()}>
                                                        Upload <br/> image
                                                    </div> */}
                                                            <button className="upload-button" onClick={onButtonClick} style={{ color: '#FFFFFF', textDecoration: 'underline', position: 'absolute' }}>
                                                                Upload <br /> image
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                            </label>
                                            {ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div>}
                                        </form>
                                    }


                                    {
                                        profileImage.length !== 0 && resizedprofileImg.length === 0 &&
                                        <form id="profilepiccontainer" style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', width: '10.875em', height: '10.875em', borderRadius: '8px', marginTop: '1.5em', marginLeft: '0.5em', alignSelf: 'center' }} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                                            <input ref={inputRef} type="file" style={{ backgroundColor: 'pink' }} id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                                            <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : ""}>
                                                <div style={{ position: 'relative' }}>
                                                    <img src={URL.createObjectURL(profileImage[0])} className="CoverPicUpload2" />

                                                </div>
                                            </label>

                                            {ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div>}
                                        </form>

                                    }

                                    {
                                        resizedprofileImg.length !== 0 &&

                                        <img src={resizedprofileImg} className="CoverPicUpload2" style={{ cursor: 'auto', borderRadius: '8px', marginTop: '1.5em', marginLeft: '0.5em', alignSelf: 'center' }} />



                                    }

                                    <div style={{ maxWidth: '15.43em', alignSelf: 'center', width: '80%' }}>
                                        <div className="ProfileName">
                                            {cookies.get("artistname")}
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginTop: '0.5em', width: '89.42%' }}>
                                            <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{ width: '1em', height: '1em', marginRight: '0.28em' }} />
                                            <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                                        </div>
                                        <div className="ProfileType">
                                            {t('Artist')}
                                        </div>
                                    </div>
                                    <div className="ReleaseMusicBtn" onClick={() => navigate("/Dashboard/releasemusic")} style={{ cursor: 'pointer' }}>{t('ReleaseMusic')}</div>
                                    <div className="StatDisclaimer">{t('Afterreleaseittakes')}</div>

                                </div>
                            </div>
                        }

                        {
                            cookies.get("artistname").length === 0 &&
                            <div style={{
                                backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ffs040ctlguylhq0jz2d")`,
                                height: '40.375em',
                                width: '19.43em',
                                backgroundSize: 'cover',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                backgroundColor: '#18222B',
                                marginBottom: '4em',
                                marginLeft: '2.5em',
                                marginRight: '1em'
                            }}>
                                <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginTop: '19.5em', width: '79.42%' }}>
                                    <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{ width: '1em', height: '1em', marginRight: '0.28em' }} />
                                    <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                                </div>
                                <span className="WelcomeToNerveH1"><span style={{ fontWeight: '500' }}>Welcome to</span>
                                    <span style={{ fontWeight: '400' }}>&nbsp;N3RVE</span>
                                    <span style={{ fontWeight: '600' }}>&nbsp;.</span>
                                </span>
                                <div className="WelcomeToNerveH2">First, let’s pick your artist name so that the world knows who you are.</div>
                                <div className="Setupartistnamebtn" style={{ cursor: 'pointer' }} onClick={() => navigate("/Dashboard/settings")}>Set up Artist Name</div>
                            </div>
                        }


                        <div className="Promotions">
                            {/* <div className="Promotion1">
                                    <div className="PromotionDate">SEP 23, 2023</div>
                                    <div className="PromotionHeading">Welcome to the New Wave of Independence</div>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rgvizsuqugtlujtnee29"} alt="Sign to yourself" className="PromotionImage"/>
                                    <div className="PromotionDesc">As a new industry alternative for independent artists, UnitedMasters provides premium music distribution services and facilitates unique partnerships between artists and the world's biggest brands.</div>
                                    <div className="PromotionBtn" onClick={()=>navigate("/Dashboard/releasemusic")} style={{cursor:'pointer'}}>Upload a Track to Get Started</div>
                            </div> */}

                            <div className="Promotion1">
                                <div className="PromotionDate">SEP 05, 2023</div>
                                <div className="PromotionHeading">GET YOUR MUSIC HEARD</div>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/lupwwwagaqahjlj5wnp8"} alt="Sign to yourself" className="PromotionImage" />
                                <div className="PromotionDesc">Make the most of your music. With N3RVE, you can distribute your music to major streaming platforms without giving up ownership of your masters.<br />
                                    Here's how to get started:<br />
                                    • Step 1: Upload Your Music<br />
                                    Drag & Drop your tracks or select them from a folder. If you're using the website, you can also upload
                                    them trem a brobbox account<br />
                                    • Step 2: Add The Extras<br />
                                    Add album artwork, featured artist details, and select your release date. We'll add the rest for you Once everything looks good, hit submit.<br />
                                    Once your release is approved, you can promote your musie even more through Masterlinks.
                                </div>
                                <div className="PromotionBtn" onClick={() => navigate("/Dashboard/releasemusic")} style={{ cursor: 'pointer' }}>Upload a Track</div>
                            </div>

                            <div className="Promotion1">
                                <div className="PromotionDate">AUG 12, 2023</div>
                                <div className="PromotionHeading">GET TO KNOW YOUR FANS: <br /> WHERE THEY ARE WHAT THEY LOVE ABOUT YOU, <br /> AND HOW TO BETTER CONNECT WITH THEM</div>
                                <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dvwroarubtmcajoytekm"} alt="Sign to yourself" className="PromotionImage" />
                                <div className="PromotionDesc">Connect your socials to learn who your fans are, what they like about you, and how to grow your audience - at every turn of your career. <br />
                                    Fueled by your data, we're here to give you the facts and turn your social numbers into real fans' love.
                                </div>
                                <div className="PromotionBtn">Connect My Account</div>
                            </div>
                        </div>
                    </div>
                </div>
            }


            {/* ******************************************** */}


            {/* MOBILe VIEW */}

            {
                dimensions.width < 768 &&
                <div className="HomeContainer" style={{ paddingBottom: '10em', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <ReactModal
                        isOpen={true}
                        contentLabel="Example Modal"
                        className="MobilePopupContainer"
                        overlayClassName="Overlay"
                    >

                        <img src={MobilePopup} style={{ marginTop: '2em', width: '100%', marginBottom: '1em' }} />


                        <div className="MobilePopupHeader">
                            Experience Full Features on Desktop
                        </div>

                        <div className="MobilePopupInfo">
                            Looks like you're on mobile. For the full suite of features, please switch to desktop. Some functionalities might be limited here.
                        </div>




                    </ReactModal>

                    <div className="HomeHeader" style={{ marginLeft: '0em', marginTop: '1em', width: '90%', fontSize: '1.5em' }}>HOME</div>

                    {
                        cookies.get("artistname").length !== 0 &&
                        <div className="ArtistWidget">
                            <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'center', width: '100%' }}>
                                {
                                    profileImage.length === 0 &&
                                    <div className="ProfilePictureUpload" style={{ cursor: 'pointer' }}>
                                        Upload profile image
                                    </div>
                                }

                                {
                                    profileImage.length !== 0 &&
                                    <img src={ArtistImage} className="ProfilePictureUpload" style={{ border: 'none' }} />
                                }

                                <div className="ProfileName">
                                    {cookies.get("artistname")}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginTop: '0.5em', width: '79.42%' }}>
                                    <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{ width: '1em', height: '1em', marginRight: '0.28em' }} />
                                    <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                                </div>
                                <div className="ProfileType">
                                    {t('Artist')}
                                </div>
                                <div className="ReleaseMusicBtn" onClick={() => navigate("/Dashboard/releasemusic")} style={{ cursor: 'pointer' }}>{t('ReleaseMusic')}</div>
                                <div className="StatDisclaimer">{t('Afterreleaseittakes')}</div>

                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ display: 'flex', flexDirection: 'row', marginTop: '1.714em', width: '79.42%', alignSelf: 'center' }}>
                                        {
                                            statsoption === 1 &&
                                            <div onClick={() => setStatsOption(1)} className="StatSliderHeaderSel">{t('1wk')}</div>
                                        }
                                        {
                                            statsoption !== 1 &&
                                            <div onClick={() => setStatsOption(1)} className="StatSliderHeader">{t('1wk')}</div>
                                        }
                                        {
                                            statsoption === 2 &&
                                            <div onClick={() => setStatsOption(2)} className="StatSliderHeaderSel">{t('1mo')}</div>
                                        }
                                        {
                                            statsoption !== 2 &&
                                            <div onClick={() => setStatsOption(2)} className="StatSliderHeader">{t('1mo')}</div>
                                        }
                                        {
                                            statsoption === 3 &&
                                            <div onClick={() => setStatsOption(3)} className="StatSliderHeaderSel">{t('All')}</div>
                                        }
                                        {
                                            statsoption !== 3 &&
                                            <div onClick={() => setStatsOption(3)} className="StatSliderHeader">{t('All')}</div>
                                        }
                                    </div>
                                    {
                                        statsoption === 1 &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', width: '79.42%', justifyContent: 'space-between', marginTop: '3.5em' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="StatHeader">{t('Streams')}</div>
                                                <div className="StatInfo">85.5k</div>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="StatHeader">{t('Followers')}</div>
                                                <div className="StatInfo">+3.8k</div>
                                            </div>
                                        </div>
                                    }


                                    {
                                        statsoption === 2 &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', width: '79.42%', justifyContent: 'space-between', marginTop: '3.5em' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="StatHeader">{t('Streams')}</div>
                                                <div className="StatInfo">402k</div>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="StatHeader">{t('Followers')}</div>
                                                <div className="StatInfo">+23.9k</div>
                                            </div>
                                        </div>
                                    }

                                    {
                                        statsoption === 3 &&
                                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', width: '79.42%', justifyContent: 'space-between', marginTop: '3.5em' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="StatHeader">{t('Streams')}</div>
                                                <div className="StatInfo">1.93M</div>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="StatHeader">{t('Followers')}</div>
                                                <div className="StatInfo">302.9k</div>
                                            </div>
                                        </div>
                                    }
                                </div>

                                <div className="SocialFollowersHeader">{t('Socialfollowers')}</div>
                                <div style={{ display: 'flex', flexDirection: 'row', width: '79.42%', alignSelf: 'center', justifyContent: 'space-between', marginBottom: '1.5em' }}>
                                    <div className="SocialMedia">{t('Facebook')}</div>
                                    <div className="SocialStat">10.8k</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', width: '79.42%', alignSelf: 'center', justifyContent: 'space-between', marginBottom: '1.5em' }}>
                                    <div className="SocialMedia">{t('Instagram')}</div>
                                    <div className="SocialStat">41.5k</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', width: '79.42%', alignSelf: 'center', justifyContent: 'space-between', marginBottom: '1.5em' }}>
                                    <div className="SocialMedia">{t('Soundcloud')}</div>
                                    <div className="SocialStat">21k</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', width: '79.42%', alignSelf: 'center', justifyContent: 'space-between', marginBottom: '1.5em' }}>
                                    <div className="SocialMedia">{t('Youtube')}</div>
                                    <div className="SocialStat">12.9k</div>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'row', width: '79.42%', alignSelf: 'center', justifyContent: 'space-between', marginBottom: '1em' }}>
                                    <div className="SocialMedia">{t('Twitter')}</div>
                                    <div className="SocialStat">23k</div>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        cookies.get("artistname").length === 0 &&
                        <div style={{
                            backgroundImage: `url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/ffs040ctlguylhq0jz2d")`,
                            height: '40.375em',
                            width: '85%',
                            backgroundSize: 'cover',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '#18222B',
                            marginBottom: '2em',
                            borderRadius: '8px'
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center', marginTop: '20.5em', width: '79.42%' }}>
                                <img src={NervousPlusLogo} alt="NERVE Subscription logo" style={{ width: '1em', height: '1em', marginRight: '0.28em' }} />
                                <div className="ProfilePlanName">{t('Nerveplusmembership')}</div>
                            </div>
                            <span className="WelcomeToNerveH1"><span style={{ fontWeight: '500' }}>Welcome to</span>
                                <span style={{ fontWeight: '400' }}>&nbsp;N3RVE</span>
                                <span style={{ fontWeight: '600' }}>&nbsp;.</span>
                            </span>
                            <div className="WelcomeToNerveH2">First, let’s pick your artist name so that the world knows who you are.</div>
                            <div className="Setupartistnamebtn" style={{ cursor: 'pointer' }} onClick={() => navigate("/Dashboard/settings")}>Set up Artist Name</div>
                        </div>
                    }


                    <div className="Promotions" style={{ width: '85%' }}>
                        {/* <div className="Promotion1" style={{paddingLeft:'1em'}}>
                                    <div className="PromotionDate" style={{marginLeft:'0em'}}>SEP 23, 2023</div>
                                    <div className="PromotionHeading" style={{marginLeft:'0em'}}>Welcome to the New Wave of Independence</div>
                                    <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/rgvizsuqugtlujtnee29"} alt="Sign to yourself" className="PromotionImage" style={{marginLeft:'0em'}}/>
                                    <div className="PromotionDesc" style={{marginLeft:'0em'}}>As a new industry alternative for independent artists, UnitedMasters provides premium music distribution services and facilitates unique partnerships between artists and the world's biggest brands.</div>
                                    <div className="PromotionBtn" onClick={()=>navigate("/Dashboard/releasemusic")} style={{cursor:'pointer',marginLeft:'0em',maxWidth:'80%'}}>Upload a Track to Get Started</div>
                            </div> */}

                        <div className="Promotion1" style={{ paddingLeft: '1em' }}>
                            <div className="PromotionDate" style={{ marginLeft: '0em' }}>SEP 05, 2023</div>
                            <div className="PromotionHeading" style={{ marginLeft: '0em' }}>GET YOUR MUSIC HEARD</div>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/lupwwwagaqahjlj5wnp8"} alt="Sign to yourself" className="PromotionImage" style={{ marginLeft: '0em' }} />
                            <div className="PromotionDesc" style={{ marginLeft: '0em' }}>Make the most of your music. With N3RVE, you can distribute your music to major streaming platforms without giving up ownership of your masters.<br />
                                Here's how to get started:<br />
                                • Step 1: Upload Your Music<br />
                                Drag & Drop your tracks or select them from a folder. If you're using the website, you can also upload
                                them trem a brobbox account<br />
                                • Step 2: Add The Extras<br />
                                Add album artwork, featured artist details, and select your release date. We'll add the rest for you Once everything looks good, hit submit.<br />
                                Once your release is approved, you can promote your musie even more through Masterlinks.
                            </div>
                            <div className="PromotionBtn" onClick={() => navigate("/Dashboard/releasemusic")} style={{ cursor: 'pointer', marginLeft: '0em', maxWidth: '80%' }}>Upload a Track</div>
                        </div>

                        <div className="Promotion1" style={{ paddingLeft: '1em' }}>
                            <div className="PromotionDate" style={{ marginLeft: '0em' }}>AUG 12, 2023</div>
                            <div className="PromotionHeading" style={{ marginLeft: '0em' }}>GET TO KNOW YOUR FANS: <br /> WHERE THEY ARE WHAT THEY LOVE ABOUT YOU, <br /> AND HOW TO BETTER CONNECT WITH THEM</div>
                            <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/dvwroarubtmcajoytekm"} alt="Sign to yourself" className="PromotionImage" style={{ marginLeft: '0em' }} />
                            <div className="PromotionDesc" style={{ marginLeft: '0em' }}>Connect your socials to learn who your fans are, what they like about you, and how to grow your audience - at every turn of your career. <br />
                                Fueled by your data, we're here to give you the facts and turn your social numbers into real fans' love.
                            </div>
                            <div className="PromotionBtn">Connect My Account</div>
                        </div>
                    </div>

                </div>
            }

        </div>
    );
}

export default Home;